import React from 'react';
function Icon(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="#e8eaed" viewBox="0 -960 960 960">
      <path fill={props.fill || '#1D252D'} d="M74.62-140L480-840l405.38 700H74.62zM178-200h604L480-720 178-200zm302-47.69q13.73 0 23.02-9.29t9.29-23.02q0-13.73-9.29-23.02T480-312.31q-13.73 0-23.02 9.29T447.69-280q0 13.73 9.29 23.02t23.02 9.29zm-30-104.62h60v-200h-60v200zM480-460z"></path>
    </svg>;
}
export default Icon;